<template>
  <div>
    <div>
      {{ radish['姓名'] }}的任职经历:
      <div class="radish-btn-text" @click="addComExp">增加</div>
    </div>
    <div class="exp-item" v-for="(ce, k) in comExp" :key="k">
      <el-date-picker
        v-model="ce['起始时间']"
        size="mini"
        type="month"
        format="yyyy.MM"
        placeholder="起始时间"
        style="width:110px"
      ></el-date-picker>
      <el-date-picker
        v-model="ce['结束时间']"
        size="mini"
        type="month"
        format="yyyy.MM"
        placeholder="结束时间"
        style="width:110px"
      ></el-date-picker>
      <el-input size="mini" v-model="ce['公司']" placeholder="公司" :title="ce['公司']" style="width:150px" />
      <el-input size="mini" v-model="ce['部门']" placeholder="部门" :title="ce['部门']" style="width:100px" />
      <el-input
        size="mini"
        v-model="ce['目前职位']"
        placeholder="目前职位"
        :title="ce['目前职位']"
        style="width:100px"
      />
      <el-input size="mini" v-model="ce['行业']" placeholder="行业" :title="ce['行业']" style="width:100px" />
      <div class="radish-btn-text" @click="delComExp(k)">删除</div>
    </div>
    <div style="text-align:right;padding-top:5px;">
      <div class="radish-btn radish-btn-primary" @click="saveComExp">保存</div>
      <div class="radish-btn" @click="onClose">关闭</div>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    radish: {
      type: Object,
      default: {},
    },
    onClose: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      comExp: [],
    }
  },
  methods: {
    showData: function(item) {
      // console.log(item)
      if (item['任职经历'] && item['任职经历'].length > 0) {
        this.comExp = item['任职经历'].sort((a, b) => {
          return a['起始时间'] < b['起始时间'] ? 1 : -1
        })
      } else {
        this.comExp = [{}]
      }
    },
    saveComExp: async function() {
      let exp = this.comExp.map(e => {
        if (e['起始时间'] instanceof Date) {
          e['起始时间'] = dateFormat(e['起始时间'], 'yyyy.mm')
        }
        if (e['结束时间'] instanceof Date) {
          e['结束时间'] = dateFormat(e['结束时间'], 'yyyy.mm')
        }
        return e
      })
      // console.log(exp);
      const res = await app.service('radish').modifyRenzhi({
        _id: this.radish._id,
        exp,
      })
      // console.log(res)
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
        // app.root.$refs.main &&
        //   app.root.$refs.main.$refs.radishList &&
        //   app.root.$refs.main.$refs.radishList.loadOne(this.radish._id)
        this.onClose()
      } else {
        this.$message.error(res.msg)
      }
    },
    delComExp: function(key) {
      this.comExp.splice(key, 1)
    },
    addComExp: function() {
      this.comExp.unshift({})
    },
  },
  watch: {
    radish: function(item) {
      this.showData(item)
    },
  },
  mounted() {
    this.showData(this.radish)
  },
}
</script>
